 <template>
    
    <v-dialog v-model="createdialog" persistent max-width="700px">
    <v-btn fab  slot="activator" color="red" dark> <v-icon>add</v-icon></v-btn>
 
    <v-card color="grey lighten-4" flat offset-md4 >
        <v-container grid-list-md pa-3>
            <v-flex xs1 style="float:right">
              <v-btn flat fab small @click="createdialog=false"> <v-icon>close</v-icon></v-btn>
            </v-flex>

            <v-layout row wrap>
              
                    <v-flex xs12>
                        <div style="color: purple; text-align:center;"><h4>Add new Question</h4></div>
                    </v-flex>
                  <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                      name="pointId"
                      label="Point ID"
                      :value="'Id: '+ (max +1)"
                      disabled
                      single-line
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                    <v-select
                      v-model="school_type"
                      name="School"
                      label="Select School type"
                      :items="avSchool"
                      single-line
                    ></v-select>
                   </v-flex>
                   <v-flex xs6>
                    <v-select
                      v-model="language"
                      name="Lang"
                      label="Select language"
                      :items="avLang"
                      single-line
                    ></v-select>
                        </v-flex>
                        </v-layout>


                    <v-flex xs12>
                        <v-text-field box multi-line 
                        label="Question"
                        name="question"
                        id="que"
                        v-model="question"
                        required></v-text-field>
                    </v-flex>
                    <v-layout row>
                    <v-flex xs12>
                        <v-text-field 
                        name="answer1" 
                        label="Answer1"
                        id="ans1"
                        v-model="options[0]"
                        maxlength="80"
                        required></v-text-field>
                    </v-flex>
                    </v-layout>
                    <v-flex xs12 >
                        <v-text-field 
                        name="answer2" 
                        label="Answer2"
                        id="ans2"
                         v-model="options[1]"
                        maxlength="80"
                    required ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                        name="answer3" 
                        label="Answer3"
                        id="ans3"
                         v-model="options[2]"
                        maxlength="80"                      
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <p>Select Correct answer</p>
                        <v-radio-group v-model="correct">
                         <v-radio
                          v-for="n in numOfAns"
                          :key="n"
                          :label="`Σωστή απάντηση ${n}`"
                          :value="n"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12></v-flex>

                    <div style="margin-left:44%;">
                        <v-spacer></v-spacer>
                        <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
                        :disabled="!formIsValid"
                        > Create New Question </v-btn>
                    </div>
                </v-layout>
            </v-container>
    </v-card>
   </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dropdown_font: ["1", "2", "3"],
      correct: null,
      createdialog: false,
      id:"",
      avSchool: ["Γενικής Παιδείας", "Ειδικής Παιδείας"],
      avLang: ["English","Greek"],
      language:"",
      options:[],
      question:"",
      school_type:null,
      point:this.$route.params.id,
    };
  },
  computed: {
    formIsValid() {
      if (this.options[0] !== "" && this.school_type!==null && this.language!=="" && this.options[1] !== ""  && this.question!== ""  && this.correct!==null){
        return true;
      } 
    },
    numOfAns(){
      var sel=0;
      if(this.options[0]!==undefined && this.options[1]!== undefined && this.options[2]!==undefined && this.options[0]!=="" && this.options[1]!== "" && this.options[2]!==""){
        sel = 3;
      }
      else if(this.options[0]!=="" && this.options[1]!==""&&this.options[0]!==undefined && this.options[1]!== undefined){
        sel = 2;
      }
      else{
        sel = 0;
      }
      return sel;
    },
    max() {
      return this.$store.getters.maxQuestionId;
    }
  },
  methods: {
    onSubmitChanges() {
      if (!this.formIsValid) {
        return;
      }
      var loption;
      var soption;
      if(this.infoTSchType==='Γενικής Παιδείας'){
          soption= 1;
      }
      else {
          soption=2;
      }
      if (this.language === "English") {
        loption = 1;
      } else {
        loption = 2;
      }
      this.createdialog = false;
      const queData = {

        correct:Number(this.correct),
        id:this.max +1,
        language:loption,
        options:this.options,
        question:this.question,
        school_type:soption,
        theme:Number(this.point),
        createdBy: this.$store.getters.user.email

      };
         this.$store.dispatch("createQuestion", queData);         
         this.point= this.$route.params.id;
         this.id= "";
         this.avSchool= ["1", "2"];
         this.avLang= ["English","Greek"];
         this.createdialog = false;
         this.school_type= null;
         this.language="";
         this.correct= "";
         this.question= "";
          this.$store.dispatch('loadSpotContent', Number(this.$route.params.id));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/edit-questions/createQuestions.vue